import { Survey } from "../../domain/entities/Survey"
import { SurveySection } from "../../domain/entities/SurveySection"
import { SurveyRepository } from "../../domain/repositories/surveyRepository"
import { UpdateSurveyCompletionRequest } from "../../domain/useCases/surveys/updateSurveyCompletion/request"
import { UpdateSurveyCompletionResponse } from "../../domain/useCases/surveys/updateSurveyCompletion/response"
import { SurveyModel } from "../models/SurveyModel"
import { SurveySectionModel } from "../models/SurveySectionModel"
import { SurveyService } from "../services/SurveyService"

export class SurveyRepositoryImpl implements SurveyRepository {
	private _surveyService
	constructor({ SurveyService }: { SurveyService: SurveyService }) {
		this._surveyService = SurveyService
	}

	public async getSurveys(): Promise<any> {
		const surveys = await this._surveyService.getSurveys()
		return surveys.map(survey => survey.toDomain())
	}
	public async getSurvey(id: number): Promise<Survey> {
		const surveys = await this._surveyService.getSurveys()
		const survey = surveys.find(s => s.id === id)
		if (!survey) throw new Error(`Survey with ID ${id} not found`)
		return survey.toDomain()
	}
	public async getSurveySections(): Promise<any> {
		const surveySections = await this._surveyService.getSurveySections()
		return surveySections.map(surveySection => surveySection.toDomain())
	}

	public async createSurvey(survey: Survey): Promise<Survey> {
		const surveyModel = await this._surveyService.createSurvey(SurveyModel.fromDomain(survey))
		return surveyModel.toDomain()
	}

	public async updateSurvey(survey: Survey): Promise<Survey> {
		const surveyModel = await this._surveyService.updateSurvey(SurveyModel.fromDomain(survey))
		return surveyModel.toDomain()
	}

	public async deleteSurvey(id: string): Promise<void> {
		return this._surveyService.deleteSurvey(id)
	}

	public async createSurveySection(surveySection: SurveySection): Promise<SurveySection> {
		const surveySectionModel = await this._surveyService.createSurveySection(
			SurveySectionModel.fromDomain(surveySection)
		)
		return surveySectionModel.toDomain()
	}

	public async updateSurveySection(surveySection: SurveySection): Promise<SurveySection> {
		const surveySectionModel = await this._surveyService.updateSurveySection(
			SurveySectionModel.fromDomain(surveySection)
		)
		return surveySectionModel.toDomain()
	}

	public async deleteSurveySection(id: number): Promise<void> {
		return this._surveyService.deleteSurveySection(id)
	}

	public async exportSurveys(surveyId: number): Promise<Blob> {
		return this._surveyService.exportSurveys(surveyId)
	}

	public async exportSurveyOptions(surveyId: number): Promise<Blob> {
		return this._surveyService.exportSurveyOptions(surveyId)
	}

	public async updateSurveyCompletion(
		request: UpdateSurveyCompletionRequest
	): Promise<UpdateSurveyCompletionResponse> {
		return this._surveyService.updateSurveyCompletion(request)
	}
}
